import Vue from 'vue';
import store from '@/store';
import CompanyProxy from "../../../proxies/CompanyProxy";
import * as types from './mutation-types';
import {LIST} from "./mutation-types";

/**
 * 권한별 업체 리스트
 * @param commit
 * @param param
 */
export const findAll = ({ commit }, param) => {
  new CompanyProxy(param)
    .all()
    .then((response) => {
      commit(types.LIST, response);
    });
};

export const findAdvertiserAll = ({ commit }, param) => {
  new CompanyProxy(param)
    .findAdvertiserAll()
    .then((response) => {
      commit(types.ADVERTISER, response);
    });
};

/**
 * 업체 등록
 * @param commit
 * @param param
 */
export const createCompany = ({ commit }, param) => {
  new CompanyProxy()
    .create(param)
    .then((response) => {
      if(response.header.returnCode === "OK") {
        Vue.router.push({
          name: 'SettingsCompany'
        });
      } else {
        alert(response.header.resultMessages);
      }
    });
};

/**
 * 업체 수정
 * @param commit
 * @param param
 */
export const editCompany = ({ commit }, param) => {
  new CompanyProxy()
    .update(param.companySeq, param)
    .then((response) => {
      if(response.header.returnCode === "OK") {
        Vue.router.push({
          name: 'SettingsCompany'
        });
      } else {
        alert(response.header.resultMessages);
      }
    });
};

/**
 * 계약서 다운로드 여부 설정
 * @param commit
 * @param param
 */
export const updateContractDownload = ({ commit }, param) => {
  new CompanyProxy()
    .updateContractDownload(param.companySeq, param.download)
    .then((response) => {
      if(response.header.returnCode === "OK") {
        alert("설정이 변경되었습니다.");
      } else {
        alert(response.header.resultMessages);
      }
    });
};

/**
 * 업체리스트 초기화
 * @param commit
 */
export const initCompanyList = ({ commit }) => {
  let response = {company: [], totalCnt: 0};
  commit(types.LIST, response);
};

export default {
  findAll,
  createCompany,
  editCompany,
  updateContractDownload,
  initCompanyList,
  findAdvertiserAll,
};
